import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user, setUser } = useAuth();
  const [status, setStatus] = useState(user ? "ok" : "checking");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setStatus("ok");
      return;
    }
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!active) return;
        setUser(data);
        setStatus("ok");
      } catch (e) {
        if (!active) return;
        setStatus("no");
        navigate("/admin/login", { replace: true });
      }
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <Loader2 className="animate-spin text-blue" size={24} />
      </div>
    );
  }
  if (status === "no") return null;
  return children;
}
